module.exports = __webpack_public_path__ + "static/media/delete-button.05b72a42.png";